import client from './client';
import { User, LikeVisibility } from '../types';

export const authApi = {
  getMe: () => client.get<User>('/auth/me').then((r) => r.data),
  logout: () => client.post('/auth/logout'),
  googleLoginUrl: (returnTo?: string) =>
    returnTo
      ? `/api/v1/auth/google?returnTo=${encodeURIComponent(returnTo)}`
      : '/api/v1/auth/google',
  updatePreferences: (data: { likeVisibility: LikeVisibility }) =>
    client.patch<User>('/auth/me/preferences', data).then((r) => r.data),
  unlinkPhone: () => client.delete('/auth/me/phone').then((r) => r.data),
  deleteAccount: () => client.delete('/auth/me').then((r) => r.data),
};
